import React, { memo } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { WarningTriangleIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { ReadinessStepTestIds } from '../../ReadinessStep.testIds';

import {
  actionsStyles,
  highlightStyles,
  iconStyles,
  nudgeStyles,
  primaryActionStyles,
  skipActionStyles,
  textStyles,
} from './BrandingNudge.styles';

const BrandingNudge = ({ onAddLogo, onSkip }) => (
  <Box data-testid={ReadinessStepTestIds.BRANDING_NUDGE} sx={nudgeStyles}>
    <Box sx={iconStyles}>
      <WarningTriangleIcon size={18} />
    </Box>
    <Typography sx={textStyles} variant="regular12">
      <Box component="span" sx={highlightStyles}>
        Your borrower will see default lender branding.{' '}
      </Box>
      Add your company logo so the invite and e-sign screens carry your brand.
    </Typography>
    <Box sx={actionsStyles}>
      <Button
        data-testid={ReadinessStepTestIds.BRANDING_ADD_LOGO}
        sx={primaryActionStyles}
        variant="text"
        onClick={onAddLogo}
      >
        <Typography variant="bold12">Add your logo (2 min)</Typography>
      </Button>
      <Button
        data-testid={ReadinessStepTestIds.BRANDING_SKIP}
        sx={skipActionStyles}
        variant="text"
        onClick={onSkip}
      >
        <Typography variant="regular12">Skip</Typography>
      </Button>
    </Box>
  </Box>
);

BrandingNudge.propTypes = {
  onAddLogo: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

export default memo(BrandingNudge);
